import Vue from "vue";
import Vuex from "vuex";
import routerModule from "@/store/modules/routerModule";
import maskModule from "@/store/modules/maskModule";
import cameraModule from "@/store/modules/cameraModule";
import horoSopeModule from "@/store/modules/horoSopeModule";
import paymentModule from "@/store/modules/paymentModule";
import userInfoModule from "@/store/modules/userInfoModule";
import initialModule from "@/store/modules/initialModule";
import settingModule from "@/store/modules/settingModule";
import handsModule from "@/store/modules/handsModule";
import tempResultModule from "@/store/modules/tempResultModule";
import vipModule from "@/store/modules/vipModule";
Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";
import createLogger from "vuex/dist/logger";
var persistPaths = ["horoSopeModule", "userInfoModule", "initialModule", "settingModule", "vipModule"];
var vuexPlugins = [createPersistedState({
  paths: persistPaths
})];

if (process.env.NODE_ENV !== "production" || process.env.VUE_APP_VUEX_LOGGER === "ON") {
  vuexPlugins.push(createLogger({
    collapsed: true // vuex logger

  }));
}

export default new Vuex.Store({
  modules: {
    routerModule: routerModule,
    maskModule: maskModule,
    cameraModule: cameraModule,
    horoSopeModule: horoSopeModule,
    paymentModule: paymentModule,
    userInfoModule: userInfoModule,
    initialModule: initialModule,
    settingModule: settingModule,
    handsModule: handsModule,
    tempResultModule: tempResultModule,
    vipModule: vipModule
  },
  state: {},
  //   mutations: indexMutation,
  //   actions: indexAction,
  //   getters: indexGetters,
  plugins: vuexPlugins,
  strict: process.env.NODE_ENV !== "production"
});